/** Payload posted via bridge.js / window.postMessage for TrainingPeaks upload. */

export type TrainingPeaksPostMessage = {
  type: 'UPLOAD_TO_TP';
  fileBase64: string;
  fileName: string;
  lang: string;
  currentLanguage: string;
  lng: string;
};

export function utf8XmlToBase64(xml: string): string {
  const bytes = new TextEncoder().encode(xml);
  let binary = '';
  for (let i = 0; i < bytes.length; i++) binary += String.fromCharCode(bytes[i]);
  if (typeof globalThis.btoa === 'function') {
    return globalThis.btoa(binary);
  }
  return Buffer.from(bytes).toString('base64');
}

export function buildTrainingPeaksPostMessage(
  generatedXml: string,
  workoutName: string,
  language: 'en' | 'pl',
): TrainingPeaksPostMessage {
  const base64 = utf8XmlToBase64(generatedXml);
  return {
    type: 'UPLOAD_TO_TP',
    fileBase64: base64,
    fileName: `${workoutName.replace(/[^a-z0-9]/gi, '_')}_${language}.zwo`,
    lang: language,
    currentLanguage: language,
    lng: language,
  };
}
